export default function() {
  this.diffComponent = {};
  let diffComponent = this.diffComponent;
  let difflib = require("jsdifflib");
  let Range = ace.require("ace/range").Range;
  let sm, opcodes, markers, cleanLines, firstLine, _handler;

  diffComponent.init = function(base, newtxt, anchor) {
    newtxt = newtxt ? newtxt : "";
    diffComponent.session = anchor.session;
    diffComponent.editor = anchor.editor;
    base = difflib.stringAsLines(base);
    newtxt = difflib.stringAsLines(newtxt);
    sm = new difflib.SequenceMatcher(base, newtxt);
    opcodes = sm.get_opcodes();
    console.log(opcodes);
    markers = [];
    for (let marker in diffComponent.session.$backMarkers) {
      if (diffComponent.session.$backMarkers[marker].clazz.indexOf("history-marker") > -1) {
        diffComponent.session.removeMarker(marker);
      }
    }
    cleanLines = opcodes.filter(code => code[0] !== "equal");
    firstLine = opcodes.find(code => code[0] !== "equal");
    if (firstLine) {
      diffComponent.editor.scrollToLine(firstLine[1] - 20);
    }
    opcodes.forEach(block => {
      if (block[0] !== "equal") {
        let marker = diffComponent.session.addMarker(
          new Range(block[1], 0, block[4], 1),
          "history-marker history-marker-" + block[0],
          "fullLine"
        );
        markers.push(marker);
      }
    });
    _handler = function() {
      if (cleanLines.some(lines => Number($(this).text()) <= lines[4] && $(this).text() >= lines[1])) {
        console.log("modification line");
      }
    };
    $(diffComponent.editor.container)
      .find(".ace_gutter-cell")
      .off(".diffview");
    $(diffComponent.editor.container)
      .find(".ace_gutter-cell")
      .on("mouseover.diffview", _handler);
  };
  diffComponent.removeMarkers = function() {
    for (let marker in diffComponent.session.$backMarkers) {
      if (diffComponent.session.$backMarkers[marker].clazz.indexOf("history-marker") > -1) {
        diffComponent.session.removeMarker(marker);
      }
    }
    // $(editor.container).find('.ace_gutter-cell').off('hover',_handler)
  };

  return diffComponent;
}
